import { useEffect, useState } from 'react';
import '../../styles/page.css';

const ScrollTop = () => {
  const [showButton, setShowButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const handleShowButton = () => {
      if (window.scrollY > 500) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleShowButton);
    return () => {
      window.removeEventListener('scroll', handleShowButton);
    };
  }, []);

  return (
    <>
      {showButton && (
        <div className="scroll__container">
          <button id="top" onClick={scrollToTop} type="button"></button>
        </div>
      )}
    </>
  );
};

export default ScrollTop;
